import { useDispatch, useSelector } from "react-redux"
import { getSiteBanners, siteBannerSelector } from "../siteBannerSlice";
import React from 'react'


export const useSiteBanner = () => {

    const dispatch = useDispatch();

    React.useState(() => {
        dispatch(getSiteBanners());
    }, [dispatch])

    const siteBanners = useSelector(siteBannerSelector.selectAll);
    const siteBannerIsLoading = useSelector(x => x.site.siteBanner.isLoading);

    return [siteBanners, siteBannerIsLoading]
}